// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import Pager from 'shared_components/table_pager';

// CSS
import './table_header.css';

// CONSTANTS
const { Text } = Typography;


class SearchPager extends React.Component {
	render() {
		const { pageSize, pageTotal, handleChangeSize, pagerTitle, currentPage} = this.props;

		const minPage = (currentPage * pageSize) + 1 - pageSize;
		const maxPage = currentPage * pageSize;
		
		const items = (()=>{
			if (pageTotal === 0){
				return `Showing 0 results`;
			}else if(pageTotal <= maxPage){
				return `Showing ${minPage} - ${pageTotal} items out of ${pageTotal} results`;
			}else {
				return `Showing ${minPage} - ${maxPage} items out of ${pageTotal} results`;
			}
		})();

		return (
			<div className="table-title">
				<div>
					<Text strong>{pagerTitle}</Text>
				</div>
				<div>
					<div className="left">
						<Text>{items}</Text>
					</div>
					<div className="right">
						<Pager handleChange={handleChangeSize} />
					</div>
				</div>
			</div>
		);
	}
}

SearchPager.propTypes = {
	handleChangeSize: PropTypes.func.isRequired,
	pageTotal: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	currentPage: PropTypes.number,
	pagerTitle: PropTypes.string,
	pagerLabel: PropTypes.string,
};

SearchPager.defaultProps = {
	pagerTitle: 'SEARCH RESULTS',
	currentPage: 1,
}

export default SearchPager;

